import React from 'react'
import { withOktaAuth } from "@okta/okta-react";
import {
  getCustomContributorSection,
  getCustomContributorData,
} from "../../helpers/api";
import Placeholder from "../misc/placeholder";
import Section from "../Profile/Section";
import PrintButton from "../misc/printButton";
import Watermark from "../misc/watermark";
import { connect } from "react-redux";
import CustomModule from "./CustomModules";

const CustomSections = props => {
  const [contributors, setContributors] = React.useState(null);
  const [sections, setSections] = React.useState(null);
  const [watermark, setWatermark] = React.useState([]);
  const [custom, setCustom] = React.useState(null);
  const [readySections, setSectionReady] = React.useState([]);
  const [total_sections, setTotalSections] = React.useState(0);

  const signalReady = (mod) => {
    setSectionReady((readySections) => readySections.concat(mod));
  };

  React.useEffect(() => {
    document.body.classList.add("print-none");

    const contributors = props.match.params.contributors.split(",");
    const sections = props.match.params.sections.split(",");
    const custom =
      props.match.params.custom === "null"
        ? []
        : props.match.params.custom.split(",");

    //get contributors
    getCustomContributorData(contributors).then((data) => {
      //console.log({ data })
      setContributors(data);
      signalReady("contributors");
    });

    if (sections.length > 0) {
      getCustomContributorSection(contributors, sections).then((data) => {
        let _sections = [];
        let final = [];
        data.forEach((s) => {
          if (_sections.indexOf(s.ContributorID) > -1) return true;
          final.push({
            contributor: {
              ContributorID: s.ContributorID,
              ContributorName: s.ContributorName,
              CountryID: s.CountryID,
              ISO2: s.ISO2,
            },
            ContributorProfileSectionID: s.ContributorProfileSectionID,
            sections: data.filter(
              (sc) => sc.ContributorName === s.ContributorName
            ),
          });
          _sections.push(s.ContributorID);
        });
        //console.log({ _sections, final })
        setSections(final);
        signalReady("sections");
        //console.log(data)
      });
    } else setSections([]);

    setCustom(custom || []);
    //console.log(1, custom, ((custom ? custom.length : 0) * contributors.length), (sections.length > 0 ? 1 : 0))
    setTotalSections(
      1 +
        (custom ? custom.length : 0) * contributors.length +
        (sections.length > 0 ? 1 : 0)
    );
  }, []);

  //console.log(total_sections)
  //console.log({ readySections })
  //console.log({ sections })

  return props.is_user_editor ? (
    <div className="container">
      <div className="row print-none mt-2">
        <div className="col">
          <div className="text-right">
            <PrintButton
              setWatermark={(ff) => setWatermark(ff)}
              sh="800"
              ready={total_sections === readySections.length}
            />
          </div>
        </div>
      </div>
      {contributors ? (
        <>
          {contributors.map((contributor) => (
            <section
              key={`contributor-${contributor.ContributorID}`}
              className="page-break-after report-page"
            >
              {" "}
              {/* className="page-break-after" */}
              <div className="row mb-3">
                {contributor.ISO2 ? (
                  <div className="col">
                    <h1>
                      <img
                        className="mr-2"
                        style={{
                          width: "48px",
                          height: "auto",
                          verticalAlign: "baseline",
                        }}
                        src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/v1/${(
                          contributor.ISO2 || ""
                        ).toLowerCase()}.png`}
                        alt={contributor.ISO3}
                      />{" "}
                      {contributor.ContributorName}
                    </h1>
                  </div>
                ) : (
                  <div className="col">
                    <h1>{contributor.ContributorName}</h1>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col">
                  <div className="main m-0 pl-0 pr-0">
                    {sections &&
                      sections
                        .filter(
                          (s) =>
                            s.contributor.ContributorID ===
                            contributor.ContributorID
                        )
                        .map((section, idx) => (
                          <React.Fragment key={`fr-${idx}`}>
                            {section.sections
                              .filter((s) => s.Markdown.length > 2)
                              .map((s) => (
                                <Section
                                  key={s.ContributorProfileSectionID}
                                  Contributor={section.contributor}
                                  countryId={section.contributor.CountryID}
                                  editable={false}
                                  {...s}
                                ></Section>
                              ))}
                          </React.Fragment>
                        ))}
                    {custom.map((custom) => (
                      <CustomModule
                        key={custom}
                        module={custom}
                        contributor={contributor}
                        signalReady={signalReady}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </section>
          ))}
        </>
      ) : (
        <Placeholder />
      )}
      <Watermark count={watermark} />
    </div>
  ) : null;
}

const mapStateToProps = ({ okta }) => {
  return {
    is_user_editor: okta.is_user_editor,
  };
};

export default withOktaAuth(connect(mapStateToProps)(CustomSections));